/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'oprema-lyn1': {
    width: 18,
    height: 18,
    viewBox: '0 0 14 15',
    data: '<path pid="0" d="M6.979 15C2.873 15 0 12.363 0 7.525 0 2.683 2.914 0 7.018 0 11.125 0 14 2.637 14 7.477c0 4.704-2.749 7.364-6.662 7.516l-.36.007z" _fill="#2D92AE" fill-rule="evenodd"/>'
  }
})
